<div class="bar-detail-container" *ngIf="!isLoading && bar">
  <!-- Hero Section -->
  <div class="bar-hero">
    <div class="bar-hero-content">
      <!-- Botón volver -->
      <button class="back-btn" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
        Volver
      </button>

      <div class="hero-title-row">
        <h1 class="bar-title">{{ bar.name }}</h1>
        <div class="hero-actions">
          <button class="hero-icon-btn" (click)="shareBar()" [title]="copied ? '¡Copiado!' : 'Compartir'">
            <svg *ngIf="!copied" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="18" cy="5" r="3"></circle>
              <circle cx="6" cy="12" r="3"></circle>
              <circle cx="18" cy="19" r="3"></circle>
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
            </svg>
            <svg *ngIf="copied" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </button>
          <span class="copied-toast" *ngIf="copied">¡Copiado!</span>
        </div>
      </div>
      
      <div class="bar-info-grid">
        <div class="info-item" *ngIf="bar.location">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span>{{ bar.location }}</span>
        </div>
        
        <div class="info-item" *ngIf="bar.type">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
          </svg>
          <span>{{ bar.type }}</span>
        </div>
        
        <div class="info-item" *ngIf="bar.rating">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <polygon points="12 2 15.09 10.26 23.77 10.36 17.39 16.88 19.54 25.64 12 20.12 4.46 25.64 6.61 16.88 .23 10.36 8.91 10.26 12 2"/>
          </svg>
          <span>{{ bar.rating.toFixed(1) }}</span>
        </div>
        
        <div class="info-item" *ngIf="bar.priceRange">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="12" y1="1" x2="12" y2="23"></line>
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
          </svg>
          <span>{{ bar.priceRange }}</span>
        </div>
      </div>

      <p class="bar-summary" *ngIf="bar.summary">{{ bar.summary }}</p>

      <!-- Estado de apertura -->
      <div class="status-section" *ngIf="currentDaySchedule">
        <div class="status-badge" [class]="isOpenNow ? 'open' : 'closed'">
          <span class="status-dot"></span>
          <span class="status-text">{{ isOpenNow ? 'Abierto ahora' : 'Cerrado' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="bar-content">
    <div class="details-grid">
      <!-- Columna izquierda -->
      <div class="details-column-left">
        <!-- Contacto -->
    <div class="detail-section" *ngIf="bar.phone || bar.web">
      <h2 class="section-title">Contacto</h2>
      <div class="contact-list">
        <div class="contact-item" *ngIf="bar.phone" (click)="callBar()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          </svg>
          <div class="contact-info">
            <span class="contact-label">Teléfono</span>
            <span class="contact-value">{{ bar.phone | phoneFormat }}</span>
          </div>
          <svg class="chevron" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        
        <div class="contact-item" *ngIf="bar.web" (click)="visitWebsite()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
            <path d="M2 12h20"></path>
          </svg>
          <div class="contact-info">
            <span class="contact-label">Sitio web</span>
            <span class="contact-value">{{ bar.web }}</span>
          </div>
          <svg class="chevron" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
      </div>
    </div>

    <!-- Ubicación -->
    <div class="detail-section" *ngIf="bar.address || bar.coordinates">
      <h2 class="section-title">Ubicación</h2>
      <app-map-preview
        *ngIf="bar.coordinates"
        [coordinates]="bar.coordinates"
        [name]="bar.name"
        class="map-preview-wrapper">
      </app-map-preview>
      <div class="address-card" (click)="openGoogleMaps()" *ngIf="bar.address">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
        <div class="address-info">
          <span class="address-value">{{ bar.address }}</span>
          <span class="address-action">Ver en Google Maps</span>
        </div>
        <svg class="chevron" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </div>
    </div>
      </div>

      <!-- Columna derecha -->
      <div class="details-column-right">
        <!-- Horarios -->
    <div class="detail-section" *ngIf="allSchedule.length > 0">
      <h2 class="section-title">Horarios</h2>
      <div class="schedule-card">
        <div class="schedule-list">
          <div class="schedule-item" *ngFor="let day of allSchedule" [class.today]="day.day === currentDaySchedule?.day">
            <span class="day-name">{{ day.day | titlecase }}</span>
            <span class="day-hours">{{ day.hours }}</span>
          </div>
        </div>
        <p class="disclaimer">* Los horarios pueden variar. Verifica con el establecimiento.</p>
      </div>
    </div>
      </div>
    </div>

  <!-- Galería de fotos -->
  <div class="detail-section" *ngIf="picturesLoading || pictures.length > 0">
    <h2 class="section-title">Fotos</h2>
    <app-gallery [pictures]="pictures" [loading]="picturesLoading"></app-gallery>
  </div>

  </div>
</div>

<!-- Loading State -->
<div class="loading-container" *ngIf="isLoading">
  <div class="spinner"></div>
  <p>Cargando información del bar...</p>
</div>

<!-- Error State -->
<div class="error-container" *ngIf="!isLoading && !bar">
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  </svg>
  <h2>Bar no encontrado</h2>
  <p>No pudimos cargar la información de este bar.</p>
  <button class="action-btn action-btn-primary" (click)="goBack()">Volver a búsqueda</button>
</div>
